<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-form ref="flowSpecialistEveryoneAuditForm" :model="formData" class="full-width-input" :disable="readOnly" :rules="rules"
             style="width: 100%;"
             label-width="120px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="名称" prop="SpecialistEveryone.specialistName">
            <el-input class="input-item" v-if="!readOnly" v-model="formData.SpecialistEveryone.specialistName"
                      :clearable="true" placeholder="名称"
            />
            <span class="input-item input-label" v-else>{{formData.SpecialistEveryone.specialistName}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="性别" prop="SpecialistEveryone.gender">
            <el-select class="input-item" v-if="!readOnly" v-model="formData.SpecialistEveryone.gender" :clearable="true" filterable
                       placeholder="性别" :loading="flowSpecialistEveryoneAuditForm.gender.impl.loading"
                       @visible-change="flowSpecialistEveryoneAuditForm.gender.impl.onVisibleChange"
                       @change="onGenderValueChange">
              <el-option v-for="item in flowSpecialistEveryoneAuditForm.gender.impl.dropdownList" :key="item.id"
                         :value="item.id" :label="item.name"
              />
            </el-select>
            <span class="input-item input-label" v-else>{{(formData.SpecialistEveryone.genderDictMap || {}).name}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系电话" prop="SpecialistEveryone.mobilePhone">
            <el-input class="input-item" v-if="!readOnly" v-model="formData.SpecialistEveryone.mobilePhone"
                      :clearable="true" placeholder="联系电话"
            />
            <span class="input-item input-label" v-else>{{formData.SpecialistEveryone.mobilePhone}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="出生日期" prop="SpecialistEveryone.birthday">
            <el-date-picker class="input-item" v-if="!readOnly" v-model="formData.SpecialistEveryone.birthday" :clearable="true"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            type="date" align="left"
                            placeholder="出生日期"
            />
            <span class="input-item input-label" v-else>{{formData.SpecialistEveryone.birthday}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="证件类型" prop="SpecialistEveryone.documentType">
            <el-select class="input-item" v-if="!readOnly" v-model="formData.SpecialistEveryone.documentType" :clearable="true" filterable
                       placeholder="证件类型" :loading="flowSpecialistEveryoneAuditForm.documentType.impl.loading"
                       @visible-change="flowSpecialistEveryoneAuditForm.documentType.impl.onVisibleChange"
                       @change="onDocumentTypeValueChange">
              <el-option v-for="item in flowSpecialistEveryoneAuditForm.documentType.impl.dropdownList" :key="item.id"
                         :value="item.id" :label="item.name"
              />
            </el-select>
            <span class="input-item input-label" v-else>{{(formData.SpecialistEveryone.documentTypeDictMap || {}).name}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="身份证号码" prop="SpecialistEveryone.idCard">
            <el-input class="input-item" v-if="!readOnly" v-model="formData.SpecialistEveryone.idCard"
                      :clearable="true" placeholder="身份证号码"
            />
            <span class="input-item input-label" v-else>{{formData.SpecialistEveryone.idCard}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="职称" prop="SpecialistEveryone.specialistTitleId">
            <el-select class="input-item" v-if="!readOnly" v-model="formData.SpecialistEveryone.specialistTitleId" :clearable="true" filterable
                       placeholder="职称" :loading="flowSpecialistEveryoneAuditForm.specialistTitleId.impl.loading"
                       @visible-change="flowSpecialistEveryoneAuditForm.specialistTitleId.impl.onVisibleChange"
                       @change="onSpecialistTitleIdValueChange">
              <el-option v-for="item in flowSpecialistEveryoneAuditForm.specialistTitleId.impl.dropdownList" :key="item.id"
                         :value="item.id" :label="item.name"
              />
            </el-select>
            <span class="input-item input-label" v-else>{{(formData.SpecialistEveryone.specialistTitleIdDictMap || {}).name}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="学历" prop="SpecialistEveryone.education">
            <el-select class="input-item" v-if="!readOnly" v-model="formData.SpecialistEveryone.education" :clearable="true" filterable
                       placeholder="学历" :loading="flowSpecialistEveryoneAuditForm.education.impl.loading"
                       @visible-change="flowSpecialistEveryoneAuditForm.education.impl.onVisibleChange"
                       @change="onEducationValueChange">
              <el-option v-for="item in flowSpecialistEveryoneAuditForm.education.impl.dropdownList" :key="item.id"
                         :value="item.id" :label="item.name"
              />
            </el-select>
            <span class="input-item input-label" v-else>{{(formData.SpecialistEveryone.educationDictMap || {}).name}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="工作单位（编制）" prop="SpecialistEveryone.companyName">
            <el-input class="input-item" v-if="!readOnly" v-model="formData.SpecialistEveryone.companyName"
                      :clearable="true" placeholder="工作单位（编制）"
            />
            <span class="input-item input-label" v-else>{{formData.SpecialistEveryone.companyName}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="统一社会信用代码" prop="SpecialistEveryone.creditCode">
            <el-input class="input-item" v-if="!readOnly" v-model="formData.SpecialistEveryone.creditCode"
                      :clearable="true" placeholder="统一社会信用代码"
            />
            <span class="input-item input-label" v-else>{{formData.SpecialistEveryone.creditCode}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="单位联系方式" prop="SpecialistEveryone.companyTel">
            <el-input class="input-item" v-if="!readOnly" v-model="formData.SpecialistEveryone.companyTel"
                      :clearable="true" placeholder="单位联系方式"
            />
            <span class="input-item input-label" v-else>{{formData.SpecialistEveryone.companyTel}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="服务单位" prop="SpecialistEveryone.serviceCompany">
            <el-input class="input-item" v-if="!readOnly" v-model="formData.SpecialistEveryone.serviceCompany"
                      :clearable="true" placeholder="服务单位"
            />
            <span class="input-item input-label" v-else>{{formData.SpecialistEveryone.serviceCompany}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="产业" prop="SpecialistEveryone.industryId">
            <el-cascader class="input-item" v-if="!readOnly" v-model="formData.SpecialistEveryone.industryId"
                         :options="flowSpecialistEveryoneAuditForm.industryId.impl.dropdownList" filterable
                         :clearable="true" :show-all-levels="false" placeholder="产业"
                         :props="{value: 'id', label: 'name', checkStrictly: true}"
                         @visible-change="flowSpecialistEveryoneAuditForm.industryId.impl.onVisibleChange"
                         @change="onIndustryIdValueChange"
            />
            <span class="input-item input-label" v-else>{{(formData.SpecialistEveryone.industryIdDictMap || {}).name}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="专长" prop="SpecialistEveryone.specialistSpecial">
            <el-input class="input-item" v-if="!readOnly" v-model="formData.SpecialistEveryone.specialistSpecial"
                      type="textarea"
                      :autosize="{minRows: 2, maxRows: 4}"
                      :clearable="true" placeholder="专长"
            />
            <span class="input-item input-label" v-else>{{formData.SpecialistEveryone.specialistSpecial}}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item label="专家照片" prop="SpecialistEveryone.specialistAvatar">
            <el-upload v-if="!readOnly"
                       class="upload-demo" name="uploadFile" :headers="getUploadHeaders"
                       :action="getUploadActionUrl('/admin/app/specialist/upload')"
                       :data="{fieldName: 'specialistAvatar', asImage: true}"
                       :on-success="onSpecialistAvatarUploadSuccess"
                       :on-remove="onSpecialistAvatarRemoveFile"
                       :before-upload="pictureFile"
                       :on-error="onUploadError"
                       :show-file-list="true"
                       :on-preview="handlePreview"
                       :limit="flowSpecialistEveryoneAuditForm.specialistAvatar.impl.maxCount"
                       :on-exceed="onUploadLimit"
                       :file-list="flowSpecialistEveryoneAuditForm.specialistAvatar.impl.fileList"
                       list-type="picture">
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
            <template v-else>
              <el-image v-for="item in parseUploadData(formData.SpecialistEveryone.specialistAvatar, {id: formData.SpecialistEveryone.id,
                  fieldName: 'specialistAvatar', asImage: true})"
                        :preview-src-list="getPictureList(formData.SpecialistEveryone.specialistAvatar, {id: formData.SpecialistEveryone.id, fieldName: 'specialistAvatar', asImage: true})"
                        class="table-cell-image" :key="item.url" :src="item.url" :fit="fit">
                <div slot="error" class="table-cell-image">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
<!--              <img v-for="item in flowSpecialistEveryoneAuditForm.specialistAvatar.impl.fileList" :key="item.url"-->
<!--                   class="table-cell-image" :src="item.url" />-->
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="身份证正面" prop="SpecialistEveryone.idPhoto">
            <el-upload v-if="!readOnly"
                       class="upload-demo" name="uploadFile" :headers="getUploadHeaders"
                       :action="getUploadActionUrl('/admin/app/specialist/upload')"
                       :data="{fieldName: 'idPhoto', asImage: true}"
                       :on-success="onIdPhotoUploadSuccess"
                       :on-remove="onIdPhotoAvatarRemoveFile"
                       :before-upload="pictureFile"
                       :on-error="onUploadError"
                       :show-file-list="true"
                       :on-preview="handlePreview"
                       :limit="flowSpecialistEveryoneAuditForm.idPhoto.impl.maxCount"
                       :on-exceed="onUploadLimit"
                       :file-list="flowSpecialistEveryoneAuditForm.idPhoto.impl.fileList"
                       list-type="picture">
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
            <template v-else>
              <el-image v-for="item in parseUploadData(formData.SpecialistEveryone.idPhoto, {id: formData.SpecialistEveryone.id,
                  fieldName: 'idPhoto', asImage: true})"
                        :preview-src-list="getPictureList(formData.SpecialistEveryone.idPhoto, {id: formData.SpecialistEveryone.id, fieldName: 'idPhoto', asImage: true})"
                        class="table-cell-image" :key="item.url" :src="item.url" :fit="fit">
                <div slot="error" class="table-cell-image">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
<!--              <img v-for="item in flowSpecialistEveryoneAuditForm.idPhoto.impl.fileList" :key="item.url"-->
<!--                   class="table-cell-image" :src="item.url" />-->
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="6" >
          <el-form-item label="服务单位营业执照" prop="Specialist.servicePhoto">
            <el-upload v-if="!readOnly"
                       class="upload-demo" name="uploadFile" :headers="getUploadHeaders"
                       :action="getUploadActionUrl('/admin/app/specialist/upload')"
                       :data="{fieldName: 'servicePhoto', asImage: true}"
                       :on-success="onServicePhotoUploadSuccess"
                       :on-remove="onServicePhotoRemoveFile"
                       :before-upload="pictureFile"
                       :on-error="onUploadError"
                       :show-file-list="true"
                       :on-preview="handlePreview"
                       :limit="flowSpecialistEveryoneAuditForm.servicePhoto.impl.maxCount"
                       :on-exceed="onUploadLimit"
                       :file-list="flowSpecialistEveryoneAuditForm.servicePhoto.impl.fileList"
                       list-type="picture">
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
            <template v-else>
              <el-image v-for="item in parseUploadData(formData.SpecialistEveryone.servicePhoto, {id: formData.SpecialistEveryone.id,
                  fieldName: 'servicePhoto', asImage: true})"
                        :preview-src-list="getPictureList(formData.SpecialistEveryone.servicePhoto, {id: formData.SpecialistEveryone.id, fieldName: 'servicePhoto', asImage: true})"
                        class="table-cell-image" :key="item.url" :src="item.url" :fit="fit">
                <div slot="error" class="table-cell-image">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
              <!--                  <img v-for="item in flowSpecialistAuditForm.servicePhoto.impl.fileList" :key="item.url"-->
              <!--                       class="table-cell-image" :src="item.url" />-->
            </template>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="成果与荣誉" prop="SpecialistEveryone.otherFiles">
            <el-upload v-if="!readOnly" name="uploadFile" :headers="getUploadHeaders" multiple
                       :action="getUploadActionUrl('/admin/app/specialistEveryone/upload')"
                       :data="{fieldName: 'otherFiles', asImage: false}"
                       :on-success="onOtherFilesUploadSuccess"
                       :on-remove="onOtherFilesRemoveFile"
                       :on-error="onUploadError" :on-exceed="onUploadLimit"
                       :limit="flowSpecialistEveryoneAuditForm.otherFiles.impl.maxCount"
                       :file-list="flowSpecialistEveryoneAuditForm.otherFiles.impl.fileList"
                       :show-file-list="true">
              <el-button :size="defaultFormItemSize" type="primary">点击上传</el-button>
            </el-upload>
            <template v-else>
              <a v-for="item in flowSpecialistEveryoneAuditForm.otherFiles.impl.fileList" :key="item.url"
                 href="javascript:void(0);" @click="downloadFile(item.url, item.name)"  style="display:flex;margin-top: 5px;">
                {{item.name}}
                <div style="margin-left: 15px;display: inline-flex">

                  <el-button type="primary" @click="downloadFile(item.url, item.name)">下载</el-button>
                  <el-button type="primary" @click="previewFile(item.url, item.filename)">预览</el-button>
                  <el-button type="primary"
                             @click="deleteOtherFiles(item,flowSpecialistEveryoneAuditForm.otherFiles.impl.fileList,index)">删除</el-button>
                </div>
              </a>
            </template>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-image-viewer v-if="imgViewerVisible" :on-close="closeImgViewer" :url-list="imgList" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
/* eslint-disable-next-line */
  import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
  import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
  import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
import flowMixins from '../../mixins/flowMixins.js';
/* eslint-disable-next-line */
  import { uploadMixin, statsDateRangeMixin } from '@/core/mixins';
/* eslint-disable-next-line */
  import { SpecialistEveryoneController, DictionaryController } from '@/api';
import { FlowOperationController } from '@/api/flowController.js';
import { validateSfz } from '@/utils/validateSfz.js';

const processDefinitionKey = 'flowSpecialistEveryAudit';

export default {
  name: 'flowSpecialistEveryoneAuditForm',
  components: {
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')

  },
  props: {
    // 是否运行时任务
    isRuntimeTask: {
      type: [Boolean, String]
    },
    // 是否草稿
    isDraft: {
      type: [Boolean, String],
      default: false
    },
    // 是否只读
    readOnly: {
      type: Boolean,
      default: false
    },
    // 流程实例id
    processInstanceId: {
      type: String
    },
    // 抄送消息id
    messageId: {
      type: String
    },
    // 当前任务实例id
    taskId: {
      type: String
    },
    // 任务变量列表
    taskVariableList: {
      type: Array
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin, flowMixins],
  data () {
    return {
      fit: 'scale-down',
      imgViewerVisible: false,
      imgList: [],
      formData: {
        SpecialistEveryone: {
          id: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          orgCode: undefined,
          deletedFlag: undefined,
          specialistName: undefined,
          specialistAvatar: undefined,
          gender: undefined,
          mobilePhone: undefined,
          companyName: undefined,
          companyTel: undefined,
          birthday: undefined,
          specialistTitleId: undefined,
          industryId: undefined,
          industryName: undefined,
          specialistSpecial: undefined,
          otherFiles: undefined,
          auditStatus: undefined,
          userId: undefined,
          relateId: undefined,
          documentType: undefined,
          education: undefined,
          idCard: undefined,
          specialistNo: undefined,
          serviceCompany: undefined,
          filingPassed: undefined,
          specialId: undefined,
          isDatasourceInit: false,
          servicePhoto: undefined
        }
      },
      rules: {
        'SpecialistEveryone.specialistName': [
          {required: true, message: '请输入姓名', trigger: 'change'}
        ],
        'SpecialistEveryone.birthday': [
          {required: true, message: '请选择出生日期', trigger: 'change'}
        ],
        'SpecialistEveryone.industryId': [
          {required: true, message: '请选择产业', trigger: 'change'}
        ],
        'SpecialistEveryone.mobilePhone': [
          {required: true, message: '请输入联系电话', trigger: 'change'}
        ],
        'SpecialistEveryone.gender': [
          {required: true, message: '请选择性别', trigger: 'change'}
        ],
        'SpecialistEveryone.idCard': [
          {required: true, validator: validateSfz, trigger: 'change'}
        ],
        // 'SpecialistEveryone.companyName': [
        //   {required: true, message: '请输入工作单位（编制）', trigger: 'change'}
        // ],
        // 'SpecialistEveryone.companyPost': [
        //   {required: true, message: '请输入职位', trigger: 'change'}
        // ],
        // 'SpecialistEveryone.companyContacts': [
        //   {required: true, message: '请输入单位联系人', trigger: 'change'}
        // ],
        // 'SpecialistEveryone.companyTel': [
        //   {required: true, message: '请输入单位联系电话', trigger: 'change'}
        // ],
        'SpecialistEveryone.specialistTitleId': [
          {required: true, message: '请选择职称', trigger: 'change'}
        ],
        'SpecialistEveryone.specialistAvatar': [
          {required: true, message: '请上传照片', trigger: 'change'}
        ],
        'SpecialistEveryone.idPhoto': [
          {required: true, message: '请上传身份证正面'}
        ],
        'SpecialistEveryone.education': [
          {required: true, message: '请输入学历', trigger: 'change'}
        ],
        'SpecialistEveryone.documentType': [
          {required: true, message: '请选择证件类型', trigger: 'change'}
        ],
        'SpecialistEveryone.specialistSpecial': [
          {required: true, message: '请输入简介'}
        ]
        // 'SpecialistEveryone.creditCode': [
        //   {required: true, message: '统一社会信用代码', trigger: 'change'}
        // ]
        // 'SpecialistEveryone.serviceCompany': [
        //   {required: true, message: '请输入服务单位', trigger: 'change'}
        // ]

      },
      // 保存草稿后返回的taskId
      draftTaskId: undefined,
      // 保存草稿后返回的流程实例ID
      draftProcessInstanceId: undefined,
      flowSpecialistEveryoneAuditForm: {
        formFilter: {
        },
        formFilterCopy: {
        },
        gender: {
          impl: new DropdownWidget(this.loadGenderDropdownList)
        },
        documentType: {
          impl: new DropdownWidget(this.loadDocumentTypeDropdownList)
        },
        specialistTitleId: {
          impl: new DropdownWidget(this.loadSpecialistTitleIdDropdownList)
        },
        education: {
          impl: new DropdownWidget(this.loadEducationDropdownList)
        },
        industryId: {
          impl: new DropdownWidget(this.loadIndustryIdDropdownList, true, 'id', 'parentId'),
          value: []
        },
        specialistAvatar: {
          impl: new UploadWidget(1)
        },
        idPhoto: {
          impl: new UploadWidget(1)
        },
        servicePhoto: {
          impl: new UploadWidget(1)
        },
        otherFiles: {
          impl: new UploadWidget(1)
        },
        isInit: false
      }
    }
  },
  methods: {
    // 启动流程
    handlerStart (operation, copyItemList) {
      // 启动并保存草稿后再次提交
      if (this.draftProcessInstanceId != null && this.draftTaskId != null) {
        return this.handlerOperation(operation, copyItemList);
      }
      return new Promise((resolve, reject) => {
        this.$refs.flowSpecialistEveryoneAuditForm.validate(valid => {
          if (!valid) return reject();
          this.preHandlerOperation(operation, true).then(res => {
            let formData = this.getMasterData(operation.type, (res || {}).assignee);
            return SpecialistEveryoneController.startAndTakeUserTaskFlowSpecialistEveryAudit(this, {
              processDefinitionKey: processDefinitionKey,
              taskVariableData: {
                ...formData.taskVariableData,
                latestApprovalStatus: operation.latestApprovalStatus
              },
              flowTaskCommentDto: {
                approvalType: operation.type
              },
              specialistEveryoneDto: {
                ...formData.masterData
              },
              ...formData.relationData,
              copyData: (copyItemList || []).reduce((retObj, item) => {
                retObj[item.type] = item.id;
                return retObj;
              }, {})
            });
          }).then(res => {
            this.$message.success('启动成功！');
            resolve();
          }).catch(e => {
            reject(e);
          });
        });
      });
    },
    // 流程操作
    handlerOperation (operation, copyItemList) {
      return new Promise((resolve, reject) => {
        this.$refs.flowSpecialistEveryoneAuditForm.validate(valid => {
          if (!valid) return reject();
          this.preHandlerOperation(operation, this.isDraft).then(res => {
            // 加签、减签操作
            if (operation.type === this.SysFlowTaskOperationType.CO_SIGN || operation.type === this.SysFlowTaskOperationType.SIGN_REDUCTION) {
              return this.submitConsign((res || {}).assignee, operation.type === this.SysFlowTaskOperationType.CO_SIGN);
            }
            // 驳回操作
            if (operation.type === this.SysFlowTaskOperationType.REJECT || operation.type === this.SysFlowTaskOperationType.REJECT_TO_TASK) {
              return FlowOperationController.rejectRuntimeTask(this, {
                processInstanceId: this.processInstanceId,
                taskId: this.taskId,
                targetTaskKey: (res || {}).targetTaskKey,
                taskComment: (res || {}).message,
                taskVariableData: {
                  latestApprovalStatus: operation.latestApprovalStatus
                }
              });
            }
            // 驳回到起点
            if (operation.type === this.SysFlowTaskOperationType.REJECT_TO_START) {
              return FlowOperationController.rejectToStartUserTask(this, {
                processInstanceId: this.processInstanceId,
                taskId: this.taskId,
                taskComment: (res || {}).message,
                taskVariableData: {
                  latestApprovalStatus: operation.latestApprovalStatus
                }
              });
            }
            // 撤销操作
            if (operation.type === this.SysFlowTaskOperationType.REVOKE) {
              this.$confirm('是否撤销此任务？').then(res => {
                return FlowOperationController.rejectHistoricTask(this, {
                  processInstanceId: this.processInstanceId,
                  taskId: this.taskId,
                  taskComment: '任务处理人撤销任务',
                  taskVariableData: {
                    latestApprovalStatus: operation.latestApprovalStatus
                  }
                });
              }).catch(e => {
                return Promise.reject(e);
              });
            }
            let formData = this.getMasterData(operation.type, (res || {}).assignee);
            let params = {
              taskId: this.taskId || this.draftTaskId,
              processInstanceId: this.processInstanceId || this.draftProcessInstanceId,
              flowTaskCommentDto: {
                taskComment: (res || {}).message,
                approvalType: operation.type,
                delegateAssignee: operation.type === this.SysFlowTaskOperationType.TRANSFER ? (res || {}).assignee : undefined
              },
              taskVariableData: {
                ...formData.taskVariableData,
                latestApprovalStatus: operation.latestApprovalStatus
              },
              copyData: (copyItemList || []).reduce((retObj, item) => {
                retObj[item.type] = item.id;
                return retObj;
              }, {})
            }
            // 非只读状态下，提交修改数据
            if (!this.readOnly) {
              // 主表数据
              params.specialistEveryoneDto = {
                ...formData.masterData
              };
              // 关联数据
              params = {
                ...params,
                ...formData.relationData
              };
            }

            return SpecialistEveryoneController.submitUserTaskFlowSpecialistEveryAudit(this, params);
          }).then(res => {
            this.reloadMessage(this);
            if (operation.type !== this.SysFlowTaskOperationType.CO_SIGN && operation.type !== this.SysFlowTaskOperationType.SIGN_REDUCTION) {
              this.$message.success(operation.label + '成功！');
            }
            resolve();
          }).catch(e => {
            console.log(e);
          });
        });
      });
    },
    // 保存草稿
    handlerDraft () {
      return new Promise((resolve, reject) => {
        let formData = this.getFormDataImpl();
        let params = {
          processDefinitionKey: processDefinitionKey,
          processInstanceId: this.processInstanceId || this.draftProcessInstanceId,
          specialistEveryoneDto: {
            ...formData.masterData
          },
          ...formData.relationData
        }
        SpecialistEveryoneController.startAndSaveDraftFlowSpecialistEveryAudit(this, params).then(res => {
          this.$message.success('草稿保存成功！');
          this.draftProcessInstanceId = res.data.processInstanceId;
          this.draftTaskId = res.data.taskId;
          resolve();
        }).catch(e => {
          reject(e);
        });
      });
    },
    // 获取表单数据
    getFormDataImpl () {
      // 一对一、一对多、多对多关联数据
      let relationData = {};

      return {
        masterData: {
          ...this.formData.SpecialistEveryone
        },
        relationData: relationData
      }
    },
    // 获取流程表单数据
    getMasterData (operationType, assignee) {
      let taskVariableData;
      if (Array.isArray(this.taskVariableList) && this.taskVariableList.length > 0) {
        taskVariableData = this.taskVariableList.reduce((retObj, item) => {
          retObj[item.variableName] = this.formData.SpecialistEveryone[item.variableName];
          return retObj;
        }, {});
      }
      // 会签操作设置多实例处理人集合
      assignee = (assignee && assignee !== '') ? assignee.split(',') : undefined;
      if (operationType === this.SysFlowTaskOperationType.MULTI_SIGN) {
        if (taskVariableData == null) taskVariableData = {};
        taskVariableData.assigneeList = assignee;
      } else if (operationType === this.SysFlowTaskOperationType.SET_ASSIGNEE) {
        if (taskVariableData == null) taskVariableData = {};
        taskVariableData.appointedAssignee = Array.isArray(assignee) ? assignee.join(',') : undefined;
      }

      return {
        ...this.getFormDataImpl(),
        taskVariableData
      }
    },
    // 初始化流程表单
    initFormData () {
      if (!this.isStartFlow) {
        // 流程办理
        let params = {
          processInstanceId: this.processInstanceId,
          taskId: this.taskId
        }
        let httpCall = null;
        if (this.isDraft || this.isDraft === 'true') {
          // 草稿数据
          httpCall = FlowOperationController.viewDraftData(this, {
            processDefinitionKey: processDefinitionKey,
            processInstanceId: this.processInstanceId
          });
        } else if (this.messageId != null) {
          // 抄送消息
          httpCall = FlowOperationController.viewCopyBusinessData(this, {
            messageId: this.messageId
          });
        } else {
          httpCall = (this.taskId && this.isRuntime) ? SpecialistEveryoneController.viewTaskBusinessDataFlowSpecialistEveryAudit(this, params) : SpecialistEveryoneController.viewHistoricTaskBusinessDataFlowSpecialistEveryAudit(this, params)
        }

        httpCall.then(res => {
          this.formData.SpecialistEveryone = { ...res.data };
          this.flowSpecialistEveryoneAuditForm.gender.impl.onVisibleChange(true).catch(e => {});
          this.flowSpecialistEveryoneAuditForm.documentType.impl.onVisibleChange(true).catch(e => {});
          this.flowSpecialistEveryoneAuditForm.specialistTitleId.impl.onVisibleChange(true).catch(e => {});
          this.flowSpecialistEveryoneAuditForm.education.impl.onVisibleChange(true).catch(e => {});
          // this.flowSpecialistEveryoneAuditForm.gender.impl.onVisibleChange(true).catch(e => {});
          this.flowSpecialistEveryoneAuditForm.industryId.impl.onVisibleChange(true).catch(e => {});

          if (this.formData.SpecialistEveryone.specialistAvatar) {
            let str = JSON.parse(this.formData.SpecialistEveryone.specialistAvatar)
            if (str[0].name === undefined) {
              str[0].name = str[0].filename
            }
            this.formData.SpecialistEveryone.specialistAvatar = JSON.stringify(str)

            let specialistAvatarDownloadParams = {
              id: this.formData.SpecialistEveryone.id,
              fieldName: 'specialistAvatar',
              asImage: true
            }
            this.flowSpecialistEveryoneAuditForm.specialistAvatar.impl.fileList = this.parseUploadData(this.formData.SpecialistEveryone.specialistAvatar, specialistAvatarDownloadParams);
          } else {
            this.formData.SpecialistEveryone.specialistAvatar = undefined
          }

          if (this.formData.SpecialistEveryone.idPhoto) {
            let str = JSON.parse(this.formData.SpecialistEveryone.idPhoto)
            if (str[0].name === undefined) {
              str[0].name = str[0].filename
            }
            this.formData.SpecialistEveryone.idPhoto = JSON.stringify(str)

            let idPhotoDownloadParams = {
              id: this.formData.SpecialistEveryone.id,
              fieldName: 'idPhoto',
              asImage: true
            }
            this.flowSpecialistEveryoneAuditForm.idPhoto.impl.fileList = this.parseUploadData(this.formData.SpecialistEveryone.idPhoto, idPhotoDownloadParams);
          } else {

          }

          if (this.formData.SpecialistEveryone.servicePhoto) {
            let str = JSON.parse(this.formData.SpecialistEveryone.servicePhoto)
            if (str[0].name === undefined) {
              str[0].name = str[0].filename
            }
            this.formData.SpecialistEveryone.servicePhoto = JSON.stringify(str)

            let servicePhotoDownloadParams = {
              id: this.formData.SpecialistEveryone.id,
              fieldName: 'servicePhoto',
              asImage: true
            }
            this.flowSpecialistEveryoneAuditForm.servicePhoto.impl.fileList = this.parseUploadData(this.formData.SpecialistEveryone.servicePhoto, servicePhotoDownloadParams);
          }

          let otherFilesDownloadParams = {
            id: this.formData.SpecialistEveryone.id,
            fieldName: 'otherFiles',
            asImage: false
          }
          this.flowSpecialistEveryoneAuditForm.otherFiles.impl.fileList = this.parseUploadData(this.formData.SpecialistEveryone.otherFiles, otherFilesDownloadParams);
          // 获取一对多、多对多数据
          this.refreshFlowSpecialistEveryoneAuditForm(true);
        }).catch(e => {});
      } else {
        // 启动流程
        let params = {
          specialistEveryoneDtoFilter: {
          },
          userId: 'userId',
          orderParam: [
            {
              fieldName: 'createTime',
              asc: false
            }
          ]
        }
        SpecialistEveryoneController.list(this, params, null, {showMask: false}).then(data => {
          // console.log(JSON.stringify(data))
          if (data.data.dataList.length > 0) {
            this.formData.SpecialistEveryone = data.data.dataList[0]
            this.flowSpecialistEveryoneAuditForm.gender.impl.onVisibleChange(true).catch(e => {});
            this.flowSpecialistEveryoneAuditForm.documentType.impl.onVisibleChange(true).catch(e => {});
            this.flowSpecialistEveryoneAuditForm.specialistTitleId.impl.onVisibleChange(true).catch(e => {});
            this.flowSpecialistEveryoneAuditForm.education.impl.onVisibleChange(true).catch(e => {});
            this.flowSpecialistEveryoneAuditForm.industryId.impl.onVisibleChange(true).catch(e => {});
          }
        })
      }
    },
    onCancel (isSuccess) {
      if (this.observer != null) {
        this.observer.cancel(isSuccess);
      }
    },
    /**
       * 性别下拉数据获取函数
       */
    loadGenderDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictGenderDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 性别选中值改变
       */
    onGenderValueChange (value) {
    },
    /**
       * 证件类型下拉数据获取函数
       */
    loadDocumentTypeDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictDocumentTypeDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 证件类型选中值改变
       */
    onDocumentTypeValueChange (value) {
    },
    /**
       * 职称ID下拉数据获取函数
       */
    loadSpecialistTitleIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictSysTitlesDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 职称ID选中值改变
       */
    onSpecialistTitleIdValueChange (value) {
    },
    /**
       * 学历下拉数据获取函数
       */
    loadEducationDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictEducationDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 学历选中值改变
       */
    onEducationValueChange (value) {
    },
    /**
       * 分类下拉数据获取函数
       */
    loadIndustryIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictIndustryDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 分类选中值改变
       */
    onIndustryIdValueChange (value) {
      this.formData.SpecialistEveryone.industryId = Array.isArray(value) ? value[value.length - 1] : undefined;
    },
    /**
       * 更新人人都是科特派申请
       */
    refreshFlowSpecialistEveryoneAuditForm (reloadData = false) {
      if (!this.flowSpecialistEveryoneAuditForm.isInit) {
        // 初始化下拉数据
      }
      this.flowSpecialistEveryoneAuditForm.isInit = true;
    },
    /**
       * 专家照片上传成功
       */
    onSpecialistAvatarUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.uploadPath = response.data.uploadPath;
        file.url = URL.createObjectURL(file.raw);
        this.flowSpecialistEveryoneAuditForm.specialistAvatar.impl.onFileChange(file, fileList);
        this.formData.SpecialistEveryone.specialistAvatar = this.fileListToJson(this.flowSpecialistEveryoneAuditForm.specialistAvatar.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
       * 移除专家照片
       */
    onSpecialistAvatarRemoveFile (file, fileList) {
      this.flowSpecialistEveryoneAuditForm.specialistAvatar.impl.onFileChange(file, fileList);
      this.formData.SpecialistEveryone.specialistAvatar = this.fileListToJson(this.flowSpecialistEveryoneAuditForm.specialistAvatar.impl.fileList);
    },

    /**
       * 成果与荣誉上传成功
       */
    onOtherFilesUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.uploadPath = response.data.uploadPath;
        file.url = URL.createObjectURL(file.raw);
        this.flowSpecialistEveryoneAuditForm.otherFiles.impl.onFileChange(file, fileList);
        this.formData.SpecialistEveryone.otherFiles = this.fileListToJson(this.flowSpecialistEveryoneAuditForm.otherFiles.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
     * 证件照上传成功
     */
    onIdPhotoUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.url = URL.createObjectURL(file.raw);
        this.flowSpecialistEveryoneAuditForm.idPhoto.impl.onFileChange(file, fileList);
        this.formData.SpecialistEveryone.idPhoto = this.fileListToJson(this.flowSpecialistEveryoneAuditForm.idPhoto.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
     * 移除证件照
     */
    onIdPhotoAvatarRemoveFile (file, fileList) {
      this.flowSpecialistEveryoneAuditForm.idPhoto.impl.onFileChange(file, fileList);
      this.formData.SpecialistEveryone.idPhoto = this.fileListToJson(this.flowSpecialistEveryoneAuditForm.idPhoto.impl.fileList);
    },

    /**
     * 服务单位营业执照
     */
    onServicePhotoUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.url = URL.createObjectURL(file.raw);
        this.flowSpecialistEveryoneAuditForm.servicePhoto.impl.onFileChange(file, fileList);
        this.formData.SpecialistEveryone.servicePhoto = this.fileListToJson(this.flowSpecialistEveryoneAuditForm.servicePhoto.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
     * 移除服务单位营业执照
     */
    onServicePhotoRemoveFile (file, fileList) {
      this.flowSpecialistEveryoneAuditForm.servicePhoto.impl.onFileChange(file, fileList);
      this.formData.SpecialistEveryone.servicePhoto = this.fileListToJson(this.flowSpecialistEveryoneAuditForm.servicePhoto.impl.fileList);
    },
    /**
       * 移除成果与荣誉
       */
    onOtherFilesRemoveFile (file, fileList) {
      this.flowSpecialistEveryoneAuditForm.otherFiles.impl.onFileChange(file, fileList);
      this.formData.SpecialistEveryone.otherFiles = this.fileListToJson(this.flowSpecialistEveryoneAuditForm.otherFiles.impl.fileList);
    },
    deleteOtherFiles (file, fileList, index) {
      fileList.splice(index, 1)
      this.onOtherFilesRemoveFile(file, fileList)
    },
    onUploadError (e, file, fileList) {
      this.$message.error('文件上传失败');
    },
    onUploadLimit (files, fileList) {
      this.$message.error('已经超出最大上传个数限制');
    },
    formInit () {
      this.initFormData();
    },
    closeImgViewer () {
      this.imgViewerVisible = false;
    },
    handlePreview (file) {
      this.imgViewerVisible = true
      this.imgList = []
      this.imgList.push(file.url)
    },
    ...mapActions(['reloadMessage'])
  },
  computed: {
    isStartFlow () {
      return this.processInstanceId == null;
    },
    isRuntime () {
      return typeof this.isRuntimeTask === 'string' ? this.isRuntimeTask === 'true' : this.isRuntimeTask;
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  }
}
</script>
